import React from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Row, Col, Input } from 'antd';
const { TextArea } = Input;

@observer
class Remark extends React.Component {
  @observable inputValue = '';
  @action.bound
  changeInputValue(e) {
    this.inputValue = e.target.value;
    this.props.changeRemark(e.target.value);
  }
  render() {
    const { disabled, data, labelCol, wrapperCol } = this.props;
    return (
      <Row style={{ width: '100%' }}>
        <Col
          span={labelCol || 2}
          style={
            !disabled
              ? {
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '4px',
                  justifyContent: 'flex-end '
                }
              : {}
          }
        >
          {!disabled && (
            <span
              style={{ fontSize: '14px', color: '#ffd100', marginRight: '4px' }}
            >
              *
            </span>
          )}
          配置说明 :&nbsp;&nbsp;
        </Col>
        <Col span={wrapperCol || 20} style={{ wordWrap: 'break-word' }}>
          {disabled ? (
            data['remark']
          ) : (
            <TextArea
              ref={node => (this.Input = node)}
              onChange={this.changeInputValue}
              value={this.inputValue}
              placeholder="请填写配置说明"
              autosize
            />
          )}
        </Col>
      </Row>
    );
  }
}

export default Remark;



// WEBPACK FOOTER //
// ./src/components/DeviceConfig/Remark.js